import {
  IDetailViewChartsWindowOption,
  type ISunsetBanner,
} from './views-types';
import type { RumInitConfiguration } from '@datadog/browser-rum';

export interface IGoogleDriveConfig {
  apiKey?: string;
  clientId?: string;
}

export interface IFeatureFlagsState {
  asyncUpdate: number;
  downloadBillingSummary: boolean;
  invoiceDownload: boolean;
  timeTrackingTimeout: number; // seconds
  careComposerLinksTasks: boolean;
  careComposerMeasurementTasks: boolean;
  careComposerMedicationTasks: boolean;
  careComposerSymptomsTasks: boolean;
  careComposerSmartGoalsTasks: boolean;
  careComposerLifestyleTasks: boolean;
  careComposerEducationTasks: boolean;
  careComposerSurveysTasks: boolean;
  careComposerCatalogDefaultCareplans: boolean;
  careComposerCatalogCarePlans: boolean;
  careComposerCatalogTasks: boolean;
  careComposerTaskScheduleQuarterly: boolean;
  auditCenter: boolean;
  billingInsight: boolean;
  careplanSwitching: boolean;
  chatAttachments: boolean;
  chatExternal: boolean;
  chatMessageDrafts: boolean;
  chatSendMessage: boolean;
  chatReadMessage: boolean;
  detailViewChartsWindow: IDetailViewChartsWindowOption;
  multipleTabsWarning: boolean;
  patientAssistantChat: boolean;
  patientAssistantChatFeedback: boolean;
  patientAssistantChatRead: boolean;
  patientAssistantThreads: boolean;
  clinicianAssistantChat: boolean;
  measurementTaskOutcomeDeletion: boolean;
  settings: boolean;
  settingsViews: boolean;
  settingsAccess: boolean;
  settingsTags: boolean;
  settingsBranding: boolean;
  settingsCohortRename: boolean;
  settingsPatients: boolean;
  settingsThresholds: boolean;
  settingsUsers: boolean;
  settingsEHR: boolean;
  settingsCohort: boolean;
  settingsProviders: boolean;
  settingsFax: boolean;
  screenShare: boolean;
  sendbirdCalls: boolean;
  temperatureTask: boolean;
  configurableViews: boolean;
  ehrSync: boolean;
  featureFlagsReady: boolean;
  filters: boolean;
  metrics: boolean;
  mixpanelFlag: boolean;
  release: string;
  sunset: ISunsetBanner;
  populationHealth: boolean;
  patientJourney: boolean;
  remotePatientMonitoring: boolean;
  timekeepBilling: boolean;
  updatedFlags?: boolean;
  datadogRumConfiguration?: IDatadogConfigurationType;
  detailUpdates: boolean;
  tagsUpdates: boolean;
  soapWidget: boolean;
  careplanUpdates: boolean;
  noteUpdates: boolean;
  videoask: boolean;
  bulkAssignments: boolean;
  bulkMessages: boolean;
  bulkTags: boolean;
  selectorPatientsCountUpdate: boolean;
  schedulingWidget: boolean;
  schedulingWidgetTrack: boolean;
  cohortAutoAssign: boolean;
  glucoseWidgetA1C: boolean;
  glucoseWidgetWrites: boolean;
  soapNoteGenerate: boolean;
  timelineReviewed: boolean;
  schedulingWidgetRequest: boolean;
  schedulingWidgetSendAllie: boolean;
  patientReportWriteToEHR: boolean;
  bulkEHRWrites: boolean;
  bulkEhrDownload: boolean;
  bulkEhrGoogleDrive: IGoogleDriveConfig;
  patientReportSendViaFax: boolean;
  patientReportSendToAllie: boolean;
  bulkEhrBillingClaim: boolean;
  devicesWidgetTask: boolean;
  patientAssignmentMenu: boolean;
  surveyTaskRepeatable: boolean;
  documentWidgetWrites: boolean;
  remotePatientMonitoringMenuAssignmentFilter: boolean;
  supportWidgetZendesk: boolean;
  supportWidgetPylon: boolean;
}

export interface IFeatureFlagsStateForTenant {
  alertsColumn: boolean;
  assignmentFilter: boolean;
  cacheTtl: number;
  datadogRumConfiguration?: IDatadogConfigurationType;
  singleRowCohorts: boolean;
  loginParallelism: number;
  metrics: boolean;
  messagesColumn: string;
  mixpanelFlag: boolean;
  patientsColumn: boolean;
  supportWidgetZendesk: boolean;
  supportWidgetPylon: boolean;
  featureFlagsReady: boolean;
}

export enum DefaultPrivacyLevelEnum {
  MASK_USER_INPUT = 'mask-user-input',
  MASK = 'mask',
  ALLOW = 'allow',
}
export interface IDatadogConfigurationType extends Omit<
  RumInitConfiguration,
  'allowedTracingUrls'
> {
  allowedTracingUrls: string[];
  logLevelVerbosity?: string;
}
